import { Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

const InfoStyles = styled.div`
	@media screen and (max-width: ${props => props.theme.breakpoint.md}) {
		margin-top: ${prop => (prop.status === false ? '45px' : '0')};
	}
	/* @media screen and (max-width: ${props => props.theme.breakpoint.sm}) {
		margin-top: 45px;
	} */
`;

const Info = ({ info, isAuthenticated }) => {
	const { status } = info;

	return (
		<InfoStyles status={status}>
			{isAuthenticated && !status && (
				<Alert
					// style={{width: '50%'}}
					severity="info"
				>
					<Typography variant="h5" component="h5">
						{info.msg}
					</Typography>
				</Alert>
			)}
		</InfoStyles>
	);
};

Info.propTypes = {
	info: PropTypes.object,
	isAuthenticated: PropTypes.bool,
};

const mapStateToProps = state => {
	return {
		isAuthenticated: state.user.isAuthenticated,
		info: state.info,
	};
};

export default connect(mapStateToProps)(Info);
